module.exports = __webpack_public_path__ + "img/balon_yes.88566dc6.png";